<div class="d-flex justify-content-between align-items-center">
  <div class="header">{{ header }}</div>
  <button
    *ngIf="showDownloadButton"
    class="btn btn-success"
    (click)="downloadClick.emit()"
  >
    <i class="fas fa-file-download"></i> Download CSV
  </button>
</div>
<div class="no-gutters">
  <app-switch-checkbox
    *ngIf="toggleText"
    [hoverable]="false"
    (change)="toggleClick.emit($event)"
  >
    {{ toggleText }}
  </app-switch-checkbox>
</div>

<div class="no-gutters">
  <div class="input-group col-4">
    <div class="input-group-prepend">
      <span class="input-group-text"><i class="fas fa-search"></i></span>
    </div>
    <input
      [placeholder]="'Filter ' + sticky.title"
      type="text"
      class="form-control form-control-sm filter-input"
      (input)="filter($event.target.value)"
    />
  </div>
</div>
<div class="d-flex wrapper">
  <app-table class="flex-grow">
    <app-table-headers>
      <app-table-header
        class="flex-{{ sticky.size || 'double' }} sticky"
        (click)="sort(sticky.prop)"
      >
        {{ sticky.title }}
      </app-table-header>
      <app-table-header
        *ngFor="let header of extraHeaders"
        (click)="sort(header.prop)"
        class="flex-{{ header.size || 'double' }}"
      >
        {{ header.title }}
      </app-table-header>
      <app-table-header
        *ngFor="let header of headers"
        class="flex-{{ header.size || 'small' }}"
        (click)="sort(header.prop)"
        >{{ header.title }}</app-table-header
      >
    </app-table-headers>

    <app-table-content>
      <app-table-row *ngFor="let stats of filteredStatistics | slice: 0:1000">
        <app-table-cell
          class="flex-{{ sticky.size || 'double' }} sticky"
          [title]="stats[sticky.prop]"
        >
          {{ stats[sticky.prop] }}
        </app-table-cell>
        <app-table-cell
          *ngFor="let header of extraHeaders"
          class="flex-{{ header.size || 'double' }}"
          (click)="header.clickable && onRowClick(stats)"
          [ngClass]="{ clickable: header.clickable }"
        >
          {{
            header.timestamp
              ? (stats[header.prop] | date: 'MMM d, yyyy, HH:mm')
              : stats[header.prop]
          }}
        </app-table-cell>
        <app-table-cell
          *ngFor="let header of headers"
          class="flex-{{ header.size || 'small' }}"
        >
          {{
            header.prop.includes('Rate')
              ? (stats[header.prop] * 100 | number: '1.0-1') + '%'
              : stats[header.prop]
          }}
        </app-table-cell>
      </app-table-row>
    </app-table-content>
  </app-table>
</div>
